export default __webpack_public_path__ + "static/runservice1-58c3914f8cce6e58eb22cd2c0519f23e.png";